//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';
import moment from 'moment-timezone';

angular.module('curalate').filter('momentFormat', [
  'SessionVarsService',
  (SessionVarsService) => {
    return (input, format, tz) => {
      const date = moment(input);

      const tzId = tz ? tz : SessionVarsService.getTimeZoneId();
      date.tz(tzId);

      return date.format(format);
    };
  }]);
